/* eslint-disable no-unused-expressions */
import { useEffect, useState, useMemo } from 'react';
import { useParams, useHistory } from 'react-router';
import { Row, Col, Button } from 'react-bootstrap';
import compose from 'recompose/compose';

import { useStore } from 'store';
import { hideLoader, showLoader } from 'store/actions/commons';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import { Card, GiftsReceivedLayout } from 'components';
import { withAgentPage, withLayout } from 'hocs';
import { useWindowSize } from 'hooks';
import { TableList } from 'components/gifts-table/TableList';
import Address from 'pages/TableFlow/Address';
import { DevolutionFlux, ThanksMessage } from 'pages/GiftsReceived';
import { getProductsById } from 'services/api/products';
import { getGiftReceivedDetail } from 'services/giftsReceived';
import { getAddressById } from 'services/commons/index';
import _isEmpty from 'lodash/isEmpty';
import IMG_DEFAULT_PRODUCT from 'assets/img/default_product.png';
import { columns as desktopColumns, mobileColumns } from './columns';
import './styles.scss';

function GiftReceivedDetailv2({ queryAgentId, queryTableId, queryAgentToken }) {

  // console.log('queryAgentId, queryTableId, queryAgentToken ',queryAgentId, queryTableId, queryAgentToken)

  const [detail, setGiftDetail] = useState({});
  const [address, setAddress] = useState({});
  const [gifts, setGifts] = useState([]);
  const [showDevolutionFlux, setShowDevolutionFlux] = useState(false);
  const [showThanksMessage, setShowThanksMessage] = useState(false);
  const { id: giftId } = useParams();
  const [, { isMobile }] = useWindowSize();
  const [giftTable, dispatch] = useStore((state) => state.giftTable.giftTable);
  const history = useHistory();

  const handleReturnClick = () => {
    setShowDevolutionFlux(true);
  };

  const handleWelcomeClick = () => {
    setShowThanksMessage(true);
  };

  useEffect(() => {
    dispatch(showLoader());
    if (giftTable || (queryAgentId && queryTableId)) {
      getGiftReceivedDetail(
        giftTable.id || queryTableId,
        giftId || queryTableId
      )
        .then((giftReceivedDetail) => {
          getAddressById(giftReceivedDetail.addressId, queryAgentToken)
            .then((address) => {
              setAddress(address.address);
            })
            .catch((error) => console.log(error));
          setGiftDetail(giftReceivedDetail);
        })
        .catch((error) => console.log(error));
    }
    return () => {
      dispatch(hideLoader());
    };
  }, [giftId, giftTable, queryTableId, queryAgentId]);

  useEffect(
    () => () => {
      dispatch(hideLoader());
    },
    []
  );

  const columns = useMemo(
    () => (isMobile ? mobileColumns : desktopColumns),
    [isMobile]
  );

  useEffect(() => {
    // console.log('detail.gifts: ',detail)
    
    if (detail.gifts) {
      getProductsById(detail?.gifts.map((item) => item?.article?.id))
        .then((giftsRes) => {

          setGifts(
            detail?.gifts?.map((gift) => {
              const itemInfo = !Array.isArray(giftsRes)
                ? giftsRes?.data.find((x) => x.id === gift?.article?.id) : null;
              return {
                ...gift,
                article: {
                  ...gift.article,
                  productName: itemInfo
                    ? itemInfo?.title
                    : gift?.description_pos || 'Nombre no disponible',
                  paidQuantity: gift?.qty_paid,
                  refundQuantity: gift?.qty_refunded,
                  description: itemInfo?.short_description || itemInfo?.description,
                  totalPrice: (gift?.price * gift?.qty_paid),
                  image: itemInfo
                    ? itemInfo?.pictures
                      ? itemInfo?.pictures[0]?.thumbnail : IMG_DEFAULT_PRODUCT
                    : IMG_DEFAULT_PRODUCT, 
                }
              };
            })
          );
        })
        .catch((error) => {
          console.log(error);
          dispatch(hideLoader());
        })
        .finally(dispatch(hideLoader()));
    }
  }, [detail]);

  useEffect(() => {
    const currentEvent = window.localStorage.getItem('currentEvent');
    const currentEventExit = window.localStorage.getItem('currentEventExit');
    if (currentEvent !== currentEventExit) {
      history.push('/regalos-recibidos');
    }

    if (_isEmpty(giftTable)) {
      dispatch(
        fetchGiftTableInfo({
          id: giftTable.id || queryTableId,
          showLoader: true
        })
      );
    }
    giftTable.id && window.localStorage.setItem('currentEvent', giftTable.id);
    return () => {
      giftTable.id && window.localStorage.setItem('currentEventExit', giftTable.id);
    };
  }, [giftTable, queryTableId]);


  // useEffect(()=>{
  //   if(gifts){
  //     console.log('gifts: ',gifts)
  //   }
  // },[gifts])
  
  return (
    <>
      <DevolutionFlux
        show={showDevolutionFlux}
        onClose={() => setShowDevolutionFlux(false)}
      />
      <ThanksMessage
        tableId={giftTable.id}
        orderId={giftId}
        show={showThanksMessage}
        onClose={() => setShowThanksMessage(false)}
      />


      {giftTable.id || queryTableId ? (
        <GiftsReceivedLayout
          id={giftTable.id}
          className="mb-5"
          showAccumulatedAmount={false}
          icono = '1'
          title='Mis regalos recibidos'
          TableHero_icon ={localStorage.getItem('icon')}
        >
          <div className="giftReceivedDetail mt-3">
            <Card className='container-receipt'>
              <Row className="giftReceivedDetail__details px-4 py-3">
                <Col xs={12} lg={4}>

                  <div className="giftDetail">
                    
                    {/* {detail.orderId && !isMobile ? (
                      <div className="giftDetail__item d-flex justify-content-between mb-3">
                        <p className="text-uppercase font-weight-bold">
                          Pedido:
                        </p>
                        <p className="text-primary">{detail.orderId}</p>
                      </div>
                    ) : null} */}

                    {detail.salesCheck ? (
                      <div className="giftDetail__item d-flex justify-content-between mb-3">
                        <p className="text-uppercase font-weight-bold text-left">
                          Ticket de compra
                        </p>
                        <p className="text-primary">{detail.salesCheck}</p>
                      </div>
                    ) : null}

                    <div className="giftDetail__item d-flex justify-content-between mb-3">
                      <p className="text-uppercase font-weight-bold">Invitado:</p>
                      <p className="text-muted">{detail.whoGaveTheGift}</p>
                    </div>

                    {/* <div className="giftDetail__item d-flex justify-content-between mb-3">
                      <p className="text-uppercase font-weight-bold">
                        Fecha de compra:
                      </p>{' '}
                      <p className="text-muted">{detail.orderDate}</p>
                    </div> */}

                    <div className="giftDetail__item d-flex justify-content-between">
                      <p className="text-uppercase font-weight-bold">
                        Estatus de compra:
                      </p>
                      <p className="text-muted">{detail.orderStatus}</p>
                    </div>
                    
                  </div>
                </Col>
                { detail.congratulationMessage && !isMobile ?
                <Col xs={12} lg={8} className="mt-3 mt-md-0">
                  <h6 className="text-uppercase font-weight-bold">
                    Felicitación:
                  </h6>
                  <p className="text-muted">{detail.congratulationMessage}</p>
                </Col>
                : null }
              </Row>

              {
                !isMobile && detail.plan === 2 && detail.shipping_method === 2 ?
                (<Row>
                  <Col className="d-flex justify-content-center text-primary font-weight-bold m-3">
                    ¡TU INVITADO DECIDIO ENTREGARTE ESTE REGALO PERSONALMENTE! NO SE REALIZA ABONO A MONEDERO
                  </Col>
                </Row>)
                : null
              }
              {
                !isMobile && detail.plan === 1 && detail.shipping_method === 2 ?
                (<Row>
                  <Col className="d-flex justify-content-center text-primary font-weight-bold m-3">
                    ¡TU INVITADO DECIDIO ENTREGARTE ESTE REGALO PERSONALMENTE! Y NO SERÁ ENTREGADO POR EL EQUIPO DE SEARS
                  </Col>
                </Row>)
                : null
              }
              {
                isMobile && detail.plan === 2 && detail.shipping_method === 2 ?
                (<Row>
                  <Col className="d-flex justify-content-center text-primary mt-3 text-center">
                    ¡Tu invitado decidió entregarte este regalo personalmente! No se realiza abono a monedero
                  </Col>
                </Row>)
                : null
              }
              {
                isMobile && detail.plan === 1 && detail.shipping_method === 2 ?
                (<Row>
                  <Col className="d-flex justify-content-center text-primary  mt-3 text-center">
                    ¡Tu invitado decidio entregarte este regalo personalmente! y no será entregado por el equipo de sears
                  </Col>
                </Row>)
                : null
              }

              <Row>
                <Col />
                {/* <Col sm={4} lg={3} xl={2}>
                  { ![3, 5].includes(detail.orderStatusId) || !detail.hasEmail ? <b>&nbsp;</b>
                    : detail.status ? (
                    <b>Enviado</b>
                  ) : giftTable?.thanks_message?.type_id === 2 ? (
                    <Button
                      variant="secondary"
                      block
                      onClick={handleWelcomeClick}
                    >
                      AGRADECER
                    </Button>
                  ) : (
                    <b>No Enviado</b>
                  )}
                </Col> */}
              </Row>
            </Card>


            <Row className="giftReceivedDetail__addressAndGifts pb-4 px-1 px-md-3 px-lg-5">
              <Col xs={12} className="mt-3">
                {
                  isMobile ? (
                    <div className='gift-list-container'>
                      <span className='title-gifts-list'>REGALO</span>
                      <div className='gift-and-congratulation-container'>
                        <div className='items-gift'>
                          {
                            gifts.map(item => (
                              <div className='item'>
                                <img src={item.article.image} className='image'/>
                                <article className='about'>
                                  <span className='name'>{item.article.productName}</span>
                                  <span className='price'>PRECIO UNITARIO: ${item?.article?.price}</span>
                                  <span className='price'>PRECIO TOTAL: ${item?.article?.price * item?.amount}</span>
                                  <span className='amount'>{item?.amount} {item?.amount > 1 ? 'piezas' : 'pieza'}</span>
                                </article>
                              </div>
                            ))
                          }
                        </div>
                        {detail.congratulationMessage && (                          
                          <article className='congratulation'>
                            <span>Mensaje de felicitación:</span> <br/>
                            <span>{detail.congratulationMessage}</span>
                          </article>
                        )}
                      </div>
                      {!detail.thanksMessageSent &&
                        <div className='button-container'>                        
                            <Button className='button' onClick={() => history.push(`/regalos-recibidos/${detail.id}/details`)} hidden={detail.thanksMessageSent}>
                              Agradecer
                            </Button>
                        </div>
                      }
                    </div>
                  ) : (
                    <TableList
                      data={gifts}
                      columns={columns({ onReturnClick: handleReturnClick })}
                      className="giftsList"
                    />
                  )
                }
              </Col>
              { detail.plan === 1 && detail.shipping_method === 2 ? null
              : <Col xs={12} className="mb-3">
                {address.id ? (
                  <Address addressId={address.id} currentAddress={address} onlyView className="my-5" />
                ) : null}
              </Col> }
            </Row>
          </div>
        </GiftsReceivedLayout>
      ) : null}
    </>
  );
}

export default compose(withLayout, withAgentPage())(GiftReceivedDetailv2);
